export const CONGESTION_STYLES = {
  Unknown: { bgColor: "#e5e7eb", textColor: "#4b5563" },
  Uncongested: { bgColor: "#dcfce7", textColor: "#16a34a" },
  Light: { bgColor: "#fef9c3", textColor: "#a16207" },
  Medium: { bgColor: "#ffedd5", textColor: "#c2410c" },
  Heavy: { bgColor: "#fee2e2", textColor: "#dc2626" },
};

export const SEVERITY_STYLES = {
  MAJOR_EVENT_SEVERITY: "text-red-700 dark:text-red-400",
  MEDIUM_EVENT_SEVERITY: "text-orange-700 dark:text-orange-400",
  MINOR_EVENT_SEVERITY: "text-yellow-700 dark:text-yellow-400",
};

export const formatDuration = (seconds) => {
  if (!seconds) return "N/A";
  const mins = Math.round(seconds / 60);
  if (mins < 60) return `${mins} min`;
  const hrs = Math.floor(mins / 60);
  const remainMins = mins % 60;
  return remainMins > 0 ? `${hrs} hr ${remainMins} min` : `${hrs} hr`;
};

export const formatDistance = (meters) => {
  if (!meters) return "N/A";
  const miles = meters / 1609.344;
  return `${miles.toFixed(1)} mi`;
};

export const formatMile = (meters) => {
  if (meters == null) return "";
  return (meters / 1609.344).toFixed(1);
};
